import React from "react";
import { Router, Routes, Route, Loadable } from "@discoverr/web/Router";
import { Bootstrap } from "@discoverr/web/Bootstrap";
import { SpaceAuthLoginPage } from "@discoverr/web/SpaceAuth";
import dateFnsLocale from "date-fns/locale/en-GB";
import en from "@discoverr/web/languages/en";
import { useNavigate } from "@discoverr/web/Router";
import { getTheme, ThemeType } from "@discoverr/web/themeOld";

// Constants
const theme: any = getTheme(
  ThemeType.Light,
  {
    main: "#B8BD9C",
    contrastText: "#fff",
  },
  {
    main: "#122c3a",
  }
);

// Views
const LoadableApp = Loadable(React.lazy(() => import("./views/App")));

const LoadableBoxApp = Loadable(React.lazy(() => import("./views/BoxApp")));

const LoadableOnsite = Loadable(React.lazy(() => import("./views/Onsite")));

// Components
const Login = () => {
  const navigate = useNavigate();
  return (
    <SpaceAuthLoginPage
      title="Imbox Cloud"
      subtitle="Sign in on the internal platform"
      image="https://imboxprotection.com/media/cp5dx0gf/imbox-flagship-box-with-screen-on.png?width=1072&height=1160&format=webp&quality=100&v=1db8e777c1a1c60"
      onSuccess={() => {
        navigate("/");
      }}
    />
  );
};

//
export const Root = () => {
  return (
    <Bootstrap
      titleTemplate="Imbox - %s"
      language={en}
      theme={theme}
      art={true}
      artConfig={{ primary: "#B8BD9C" }}
      dateFnsLocale={dateFnsLocale}
    >
      <Router>
        <Routes>
          <Route path="/auth/login" element={<Login />} />
          <Route path="/*" element={<LoadableApp />} />
          <Route path="/box-app/*" element={<LoadableBoxApp />} />
          <Route path="/onsite/*" element={<LoadableOnsite />} />
        </Routes>
      </Router>
    </Bootstrap>
  );
};
